
if (typeof AJS !== "undefined") {
    __webpack_require__.p = AJS.contextPath() + "/s/65609d31-3a1a-4792-9ae5-95388d4ff495/_/download/resources/com.atlassian.auiplugin:assets-65609d31-3a1a-4792-9ae5-95388d4ff495/";
}
